import { Component, Injector, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MultipleModalService } from './multiple-modal.indra.service';

@Component({
	selector: 'app-multiple-modal',
	template: `<ng-template #modalplaceholder></ng-template>`
})
export class MultipleModalPlaceholderComponent implements OnInit {

	@ViewChild('modalplaceholder', { read: ViewContainerRef }) viewContainerRef;

	constructor(
		private multipleModalService: MultipleModalService,
		private injector: Injector
	) {
	}

	ngOnInit(): void {
		this.multipleModalService.registerViewContainerRef(this.viewContainerRef);
		this.multipleModalService.registerInjector(this.injector);
	}

}
